import { render, staticRenderFns } from "./Synchronize.vue?vue&type=template&id=1b30df5e&scoped=true&"
import script from "./Synchronize.vue?vue&type=script&lang=js&"
export * from "./Synchronize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b30df5e",
  null
  
)

export default component.exports